import { InjectionToken } from '@angular/core';
import { ChatBlock } from '@features/shared/chat/domain/models/chat-block.model';
import { Observable } from 'rxjs';

export interface IStaffChatBlockRepository {
  getConversationState(conversationId: string): Observable<ChatBlock>;
}

export const STAFF_CHAT_BLOCK_REPOSITORY = new InjectionToken<IStaffChatBlockRepository>(
  'IStaffChatBlockRepository',
);
